import React from 'react';

import {
  Form,
  validateForm,
  isFormValid,
} from '@arreeba/arreeba-form';

import {
  restaurantsCoordinatesMedian
} from '@arreeba/ristoranti-frontend-lib/lib/selectors/common';
import LocationHelpers from '@arreeba/ristoranti-frontend-lib/lib/helpers/location';

import { connect } from '../../util';
import GoogleMap from '../../components/google-map';
import AddressFormHelper from '../../lib/address-form-helpers';

class OrderDeliveryAddress extends React.Component {
  constructor(props) {
    super(props);
    this.tmpLocation = {};
    const prevLocation = this.props.order.deliveryLocation;
    const prevAddress = this.props.order.deliveryAddress;
    this.formConfig = AddressFormHelper.getConfig(prevLocation, prevAddress)

    // if a deliveryLocation has been set up, the user is updating
    // an address (e.g. after geolocation)
    const location = (prevLocation) ? { ...prevLocation.geometry.location } : null;
    this.state = {
      location,
      errors: {},
    };

    this.onLocationChange = this.onLocationChange.bind(this);
    this.checkDeliveryAddress = this.checkDeliveryAddress.bind(this);
  }

  onLocationChange(arg) {
    if (arg.name === 'location.latitude') {
      this.tmpLocation.latitude = arg.value;
    }
    if (arg.name === 'location.longitude') {
      this.tmpLocation.longitude = arg.value;
    }

    if (this.tmpLocation.latitude && this.tmpLocation.longitude) {
      this.setState({
        location: {
          lat: this.tmpLocation.latitude,
          lng: this.tmpLocation.longitude,
        },
      });
      this.tmpLocation = {};
    }
  }

  checkDeliveryAddress(data) {
    const errors = validateForm(data, this.formConfig);
    if (!isFormValid(errors)) {
      this.setState({ errors });
      return;
    }
    const { latitude, longitude } = data.location;
    const description = LocationHelpers.formatAddressDescription(data.address);
    const location = LocationHelpers.deliveryAddressFactory(
      description,
      latitude,
      longitude,
      data.address,
    );
    this.props.services.order.deliveryAddressCheck(
      this.props.app.id,
      location,
      this.props.actions.order,
    );
    this.props.actions.order.setDeliveryAddress(location);
  }

  render() {
    const coord = this.state.location ?
      this.state.location :
      this.props.defaultCoord;
    const markers = this.state.location ? [this.state.location] : [];

    return (
      <main>
        <div className="deliveryAddress__map">
          <GoogleMap
            markers={markers}
            center={coord}
          />
        </div>
        <div className="deliveryAddress__autocomplete">
          <Form
            data={this.formConfig}
            errors={this.state.errors}
            onSave={this.checkDeliveryAddress}
            onSubmit={this.checkDeliveryAddress}
            submitButtonLabel="CONTINUA"
            submitClassNames={['btn-submit']}
          />
        </div>
      </main>
    );
  }
}

const mapStateToProps = (state, props) => ({
  url: props.url,
  app: state.app,
  user: state.user,
  order: state.order,
  defaultCoord: restaurantsCoordinatesMedian(state, props),
});

export default connect(OrderDeliveryAddress, { mapStateToProps });



// WEBPACK FOOTER //
// ./src/containers/order/order-delivery-address.js